import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Drop noise from browser extensions / injected scripts. These surface as
    // opaque messages (e.g. "ga") caught by the global onerror handler.
    ignoreErrors: [
      // Bare/opaque messages thrown by injected third-party scripts.
      /^Error: ga$/,
      // Common extension + injected-script chrome.
      "top.GLOBALS",
      /^ResizeObserver loop/,
      /extension:\//i,
    ],
    beforeSend(event) {
      // Drop unhandled global-onerror events whose stack has no first-party
      // frames — these come from browser extensions / injected scripts, not us.
      const isUnhandled = event.exception?.values?.some(
        (v) => v.mechanism?.handled === false,
      );
      if (isUnhandled) {
        const frames = event.exception?.values?.flatMap(
          (v) => v.stacktrace?.frames ?? [],
        );
        if (frames && frames.length > 0 && !frames.some((f) => f.in_app)) {
          return null;
        }
      }
      return event;
    },
  });
}

export { Sentry };
